import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import "./Courses.css";

import IgniteNavbar from "../../layout/IgniteNavbar";
import IgniteHeader from "../../layout/IgniteHeader";


import CourseModules from "./Components/CourseModules";
import CourseProgress from "./Components/CourseProgress";
import LearningStats from "./Components/LearningStats";


const Courses = () => {
 // Hide website footer
  useEffect(() => {
       window.scrollTo({
         top: 0,
         behavior: "smooth",
       });
     }, []);
  useEffect(() => {
    const navbar = document.querySelector("header, .navbar");
    const footer = document.querySelector("footer");
  
   
    if (navbar) navbar.style.display = "none";
    if (footer) footer.style.display = "none";
  
    return () => {
      // 🔥 மீண்டும் restore
      if (navbar) navbar.style.display = "";
      if (footer) footer.style.display = "";
    };
  }, []);
    /* ==============================
       USER
    ============================== */

    const email =
        localStorage.getItem(
            "user_email"
        );


    /* ==============================
       COURSE STATUS
    ============================== */

    const [courseStatus, setCourseStatus] =
        useState({

            neuroPerformanceFoundational: false,

            eyeHealthAthleticEdition: false,

            eyeHealthDetailed: false,

            allCoursesCompleted: false

        });


    const [loading, setLoading] =
        useState(true);


    /* ==============================
       FETCH COURSE STATUS
    ============================== */

    useEffect(() => {

        if (!email) {

            setLoading(false);

            return;

        }

        fetchCourseStatus();

    }, [email]);


    const fetchCourseStatus = async () => {

        try {

            setLoading(true);

            const res =
                await axios.get(

                    `/api/ignite/course/status/${email}`

                );


            if (res.data.success) {

                setCourseStatus({

                    neuroPerformanceFoundational:
                        res.data.courses
                            ?.neuroPerformanceFoundational || false,

                    eyeHealthAthleticEdition:
                        res.data.courses
                            ?.eyeHealthAthleticEdition || false,

                    eyeHealthDetailed:
                        res.data.courses
                            ?.eyeHealthDetailed || false,

                    allCoursesCompleted:
                        res.data.allCoursesCompleted || false

                });

            }

        }

        catch (err) {

            console.error(

                "Course Status Error:",

                err

            );

        }

        finally {

            setLoading(false);

        }

    };


    /* ==============================
       COURSE DATA
    ============================== */

    const courses = [

        {

            id:
                "neuroPerformanceFoundational",

            title:
                "Neuro Performance Foundational Program",

            description:
                "Build the foundation for visual and cognitive performance.",

            completed:
                courseStatus
                    .neuroPerformanceFoundational

        },

        {

            id:
                "eyeHealthAthleticEdition",

            title:
                "Eye Health Reset – Athletic Edition",

            description:
                "Improve eye health and visual readiness for athletic performance.",

            completed:
                courseStatus
                    .eyeHealthAthleticEdition

        },

        {

            id:
                "eyeHealthDetailed",

            title:
                "Eye Health Reset – Detailed",

            description:
                "Explore detailed eye health and performance practices.",

            completed:
                courseStatus
                    .eyeHealthDetailed

        }

    ];


    /* ==============================
       COMPLETED COUNT
    ============================== */

    const completedCount =
        courses.filter(

            course =>
                course.completed

        ).length;


    const overallProgress =
        Math.round(

            (

                completedCount /

                courses.length

            ) * 100

        );


    if (loading) {

        return (

            <div className="ignite-courses">

                <IgniteNavbar />

                <main className="ignite-courses-main">

                    <IgniteHeader

                        title="Courses"

                        subtitle="Learn. Practice. Apply. Improve Your Performance."

                    />

                    <div className="courses-loading">

                        Loading Courses...

                    </div>

                </main>

            </div>

        );

    }


    return (

        <div className="ignite-courses">

            <IgniteNavbar />

            <main className="ignite-courses-main">

                <IgniteHeader

                    title="Courses"

                    subtitle="Learn. Practice. Apply. Improve Your Performance."

                />


               

                {/* =========================
                    COURSE MODULES
                ========================= */}

                <div className="courses-section">

                    <CourseModules

                        courses={courses}

                    />

                </div>


                {/* =========================
                    PROGRESS
                ========================= */}

                <div className="courses-row">

                    <CourseProgress

                        courses={courses}

                        completedCount={completedCount}

                        overallProgress={overallProgress}

                    />


                    <LearningStats

                        courses={courses}

                    />

                </div>

            </main>

        </div>

    );

};


export default Courses;